import React from "react";
import { Input } from "./Input";
import { InputDate } from "./Date";
import { Checkbox } from "./Checkbox";
import { FIELD_TYPES } from "./utils";

export const Fields = (props) => {
  const fields = {
    [FIELD_TYPES.text]: <Input {...props} />,
    [FIELD_TYPES.date]: <InputDate {...props} />,
    [FIELD_TYPES.checkbox]: <Checkbox {...props} />,
  };

  return fields[props.fieldType];
};
